import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SchemaOrg from "@/components/feature/SchemaOrg";
import HeroSection from "./components/HeroSection";
import LatestSection from "./components/LatestSection";
import RankingSection from "./components/RankingSection";
import BrandSection from "./components/BrandSection";
import WeeklySection from "./components/WeeklySection";
import ReviewsSection from "./components/ReviewsSection";
import CtaSection from "./components/CtaSection";

const formSubmitUrl = "http://yuanyunge.cn/";

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: "樱花动漫网 - 首页",
          url: "http://yuanyunge.cn/",
          description: "樱花动漫网首页，推荐最新热门动漫、电视剧、电影在线观看，免费高清动漫大全。",
          inLanguage: "zh-CN",
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <LatestSection />
          <RankingSection />
          <WeeklySection />
          <BrandSection />
          <ReviewsSection />
          <CtaSection />
        </main>

        <Footer formUrl={formSubmitUrl} />
      </div>
    </>
  );
}